import { createSlice } from "@reduxjs/toolkit";
import Cookies from "js-cookie";

const initialState = {
    signupData: Cookies.get('signupData') ? JSON.parse(Cookies.get('signupData')) : null,
    loginData: Cookies.get('loginData') ? JSON.parse(Cookies.get('loginData')) : null,
    token: localStorage.getItem('token') || null, 
    userId: localStorage.getItem('userId') ? JSON.parse(localStorage.getItem('userId')) : null,
    avatar: localStorage.getItem('avatar') || null, 
};

export const user_information = createSlice({
    name: "user",
    initialState,
    reducers: {
        setSignupData(state, action) {
            state.signupData = action.payload;
            //console.log("SignupData in redux: ", state.signupData);
            Cookies.set('signupData', JSON.stringify(state.signupData)); 
        },
        logout(state) {
            state.loginData = null;
            state.signupData = null; 
            state.token = null;
            state.userId = null;
            state.avatar = null;
            Cookies.remove('loginData');
            Cookies.remove("signupData");
            localStorage.removeItem("token");
            localStorage.removeItem("userId");
            localStorage.removeItem("avatar");
        },
        setLoginData(state, action) {
            state.loginData = action.payload;
            Cookies.set('loginData', JSON.stringify(state.loginData)); 
        },
        setToken(state, action) {
            //console.log("Action payload (token): ", action.payload);
            state.token = action.payload;
            localStorage.setItem('token', action.payload); 
            //console.log("Token in state: ", state.token);
        },
        setuserId(state, action) {
            //console.log("Action payload (userId): ", action.payload);
            state.userId = action.payload;
            localStorage.setItem('userId', JSON.stringify(state.userId));
            //console.log("userId in state: ", state.userId);
        },
        setAvature(state, action){
            state.avatar = action.payload;
            //console.log("Avatar : ", state.avatar);
            localStorage.setItem('avatar', state.avatar);
        }
    }
});

export const { setSignupData, logout, setLoginData, setToken, setuserId, setAvature } = user_information.actions;
export default user_information.reducer;
